var React = require('react');

function ScreenSharing (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_45948","data-name":"Group 45948","transform":"translate(-16 -236)"},[React.createElement("rect",{"id":"Rectangle_6960","data-name":"Rectangle 6960","width":"19","height":"14","rx":"3","transform":"translate(16 236)","fill":"#fff","key":0}),React.createElement("path",{"id":"Union_1","data-name":"Union 1","d":"M76.532-109.274l-2.09-2.091a1.3,1.3,0,0,1-.773-1.189,1.31,1.31,0,0,1,.012-.18,1.366,1.366,0,0,1,.4-.92l2.341-2.341a1.372,1.372,0,0,1,1.939,0,1.371,1.371,0,0,1,0,1.94l-.2.2h3.207a1.3,1.3,0,0,1,1.3,1.3,1.3,1.3,0,0,1-1.3,1.3H78.152l.18.18a1.272,1.272,0,0,1,0,1.8,1.268,1.268,0,0,1-.9.373A1.271,1.271,0,0,1,76.532-109.274Z","transform":"translate(-87.069 164.831) rotate(90)","fill":"#858585","key":1})]));
}

ScreenSharing.defaultProps = {"width":"19","height":"14","viewBox":"0 0 19 14"};

module.exports = ScreenSharing;

ScreenSharing.default = ScreenSharing;
